





















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import DocumentSignature from "@/employee/components/DocumentSignature.vue";
import WizardNavigation from "@/employee/components/investments/drivewealth/wizard/WizardNavigation.vue";
import { DrivewealthWizardStep, FeatureFlags } from "@/shared/types";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component ({
  components: {
    DocumentSignature,
    WizardNavigation,
  }
})
export default class CustomerSignature extends Vue {
  @Prop({required: false})
  isPreenrollment: boolean;

  @Prop({required: false})
  isCreatingAccount: boolean;

  @Prop({required: false})
  isSavingAccountClaims: boolean;

  @Prop({required: false})
  accountId: number;

  isSigned = false;
  signatureData: string = null;
  isSubmitting = false;

  featureFlagStore = useFeatureFlagStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();

  mounted () {
    this.drivewealthWizardStore.loadBalanceAndIsAllowedToPreenroll({});
  }

  get wizardStep () {
    return DrivewealthWizardStep.CustomerSignature;
  }

  get isLoaded () {
    return this.drivewealthWizardStore.isBalanceAndIsAllowedToPreenrollLoaded;
  }

  get disclosureDocumentKey () {
    return this.featureFlagStore.flags.bend15067EnableAdvisorAgreementsByType ?
      drivewealth.advisoryDocumentKeyMap[this.drivewealthWizardStore.accountType] :
      drivewealth.advisoryDocumentKeyMapOld[this.drivewealthWizardStore.accountType];
  }

  tryAdvance () {
    this.createAccount();
  }

  get createAction () {
    // TODO: Doesn't this kind of logic belong in a store?
    if (this.isCreatingAccount) { return this.drivewealthWizardStore.createCustomerAccount; }
    if (this.isPreenrollment) { return this.drivewealthWizardStore.preenrollCustomer; }
    if (this.isSavingAccountClaims) { return this.drivewealthWizardStore.claimAccount; }

    return () => Promise.reject();
  }

  createAccount () {
    if (this.isSubmitting) { return; }

    this.isSubmitting = true;
    this.$emit("submitting", true);

    this.createAction(this.accountId)
      .then(() => {
         this.drivewealthWizardStore.setWizardStepComplete(DrivewealthWizardStep.CustomerSignature);
      })
      .finally(() => {
        this.isSubmitting = false;
        this.$emit("submitting", false);
      });
  }

  onSigned (val) {
    if (val.length > 0) {
      this.isSigned = true;
      this.drivewealthWizardStore.setSignatureContent(val);
    } else {
      this.isSigned = false;
    }
  }
}
